import { type ReactNode } from "react";
import * as RxCheckbox from "@radix-ui/react-checkbox";

import Row from "../../components/ui/Row";
import { ccn } from "../../styles/utils";
import { CheckFilledIcon } from "./icons";

const commonStyles =
  "flex h-6 w-6 shrink-0 cursor-pointer appearance-none items-center justify-center rounded-[4px] border-2 outline-none transition-colors";

const variantStyles = {
  light: {
    enabled:
      "border-blue-dark20 bg-white hover:border-blue-dark data-[state=checked]:border-blue-dark data-[state=checked]:bg-blue-dark",
  },
  dark: {
    enabled:
      "border-blue-dark bg-blue-dark hover:bg-white data-[state=checked]:bg-blue-dark",
  },
};

export default function Checkbox({
  name,
  label,
  id,
  defaultChecked,
  onChange,
  checked,
  required,
  variant = "light",
}: {
  label: ReactNode;
  id?: string;
  name?: string;
  defaultChecked?: boolean;
  onChange?: (value: boolean) => void;
  checked?: boolean;
  variant?: keyof typeof variantStyles;
  required?: boolean;
}) {
  return (
    <Row center="y">
      <RxCheckbox.Root
        required={required}
        id={id}
        name={name}
        className={ccn(commonStyles, variantStyles[variant].enabled)}
        checked={checked}
        defaultChecked={defaultChecked}
        onCheckedChange={
          onChange ? (checked) => onChange(checked as boolean) : undefined
        }
      >
        <RxCheckbox.Indicator>
          <CheckFilledIcon fill="white" className="h-4 w-4" />
        </RxCheckbox.Indicator>
      </RxCheckbox.Root>

      <label className="cursor-pointer pl-2 text-blue-dark" htmlFor={id}>
        {label}
      </label>
    </Row>
  );
}
